import React, { useState } from 'react'
import {
  Box,
  Grid,
  Collapse,
  IconButton,
  makeStyles,
  Chip
} from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import clsx from 'clsx'
import PaperAster from '../PaperAster'
import ListField from '../list_field'
import { CLIENT_TITLE } from '../../lib/constants'
import PhoneMaskButton from '../form/PhoneMaskButton'
import CloseSale from '../CloseSaleDialogButton'

const useStyles = makeStyles(theme => ({
  fullName: { fontSize: '22px' },
  vin: { fontSize: '1.1rem' },
  price: {
    fontSize: '1rem'
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  }
}))

function ClientInfo({ sale: { id, client = {}, seoNumber }, children }) {
  const classes = useStyles()
  const [isExpanded, setExpand] = useState(false)

  const handleCollapse = () => {
    setExpand(!isExpanded)
  }

  const fullName = [client.lastName, client.firstName, client.middleName]
    .filter(name => !!name)
    .join(' ')

  return (
    <PaperAster mb={2}>
      {children}
      <Box display="inline-flex" flexWrap="wrap" alignItems="center">
        <Box my={1} fontSize="18px" mr={2}>
          {fullName}
        </Box>
        <Box mr={1}>
          <Chip size={'small'} style={{ height: 18 }} label={`ID: ${id}`} />
        </Box>
        <CloseSale />
        <Box my={1} mr={2}>
          <IconButton
            onClick={handleCollapse}
            className={clsx(classes.expand, {
              [classes.expandOpen]: isExpanded
            })}
            size="small"
            aria-expanded={isExpanded}
            aria-label="Полная информация"
          >
            <ExpandMore />
          </IconButton>
        </Box>
      </Box>
      <Collapse
        component={Box}
        mt={2}
        in={isExpanded}
        timeout="auto"
        unmountOnExit
      >
        <Grid container spacing={1}>
          <Grid item md={4} xs={12}>
            <ListField
              title={CLIENT_TITLE.phoneNumber}
              value={
                <PhoneMaskButton phoneNumber={client.phoneNumber} saleId={id} />
              }
            />
          </Grid>
          {!!seoNumber && (
            <Grid item md={4} xs={12}>
              <ListField title={'Номер талона СЭО'} value={seoNumber} />
            </Grid>
          )}
        </Grid>
      </Collapse>
    </PaperAster>
  )
}

export default ClientInfo
